import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const DivinationPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  
  // 如果用户未登录，重定向到登录页面
  if (!user) {
    navigate('/login');
    return null;
  }
  
  return (
    <div className="space-y-8">
      <section className="cyber-panel p-6 rounded-lg bg-gradient-to-r from-cyber-dark to-black">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <h1 className="text-3xl font-xianxia text-cyber-primary mb-2 cyber-title">修真占卜系统</h1>
            <p className="text-cyber-light">
              通过古老占卜之术与现代数据分析，探索你的修真道路
            </p>
          </div>
        </div>
      </section>
      
      <div className="cyber-panel p-6 rounded-lg">
        <div className="text-center p-8">
          <div className="text-5xl text-cyber-accent mb-6">
            <i className="fas fa-yin-yang"></i>
          </div>
          <h2 className="text-2xl font-cyber text-cyber-primary mb-4">占卜系统正在调试中</h2>
          <p className="text-cyber-light mb-4">修真占卜系统功能正在紧张开发中，敬请期待...</p>
          <p className="text-cyber-light mb-6">未来您将可以通过奇门遁甲、太玄占、灵气感应、五行占卦等方式，预测您的修真道路与机缘。</p>
          <button
            className="cyber-button"
            onClick={() => navigate('/dashboard')}
          >
            返回仪表板
          </button>
        </div>
      </div>
    </div>
  );
};

export default DivinationPage;
